import Reflux from "reflux";

export default Reflux.createActions([
  "displayError",
  "requestFeaturedBooks",
  "trackMenuImpression",
]);
